/**
 * Shown on a style editor opened by someone without `manage_styling`: the style is
 * visible but read-only. Deliberately read-only rather than hidden — a missing
 * editor makes the map look unconfigurable rather than protected.
 */
export const STYLING_MANAGED_MESSAGE = "Styling is managed by your organisation's administrators.";
